module.exports = __webpack_public_path__ + "static/media/customer-uscranberries.7ec22c4d.png";